import React, {useEffect} from 'react'
import { GoogleMap, Marker, useJsApiLoader } from "@react-google-maps/api";
import PropTypes from "prop-types";
import StreetViewMap from "./StreetViewMap";

const center = {
    lat: 35.1714978,
    lng: 136.8847575,
};

const PropertyMap = (props) => {
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: process.env.REACT_APP_GOOGLE_MAP_API_KEY,
    })
    const [map, setMap] = React.useState(null)
    const [center, setCenter] = React.useState({
        lat: 0,
        lng: 0,
    });

    useEffect(() => {
        setCenter({
            lat: props.latitude,
            lng: props.longitude,
        })
    }, [props]);

    const onLoad = React.useCallback(function callback(map) {
        // This is just an example of getting and using the map instance!
        // const bounds = new window.google.maps.LatLngBounds(center);
        // map.fitBounds(bounds);
        // setMap(map)
    }, [])

    const onUnmount = React.useCallback(function callback(map) {
        // setMap(null)
    }, [])

    return isLoaded ? (
        <GoogleMap
            mapContainerClassName="Property-map"
            center={center}
            zoom={17}
            onLoad={onLoad}
            onUnmount={onUnmount}
        >
            { /* Child components, such as markers, info windows, etc. */ }
            <Marker position={center} />
        </GoogleMap>
    ) : <></>
};
PropertyMap.propTypes = {
    latitude: PropTypes.number,
    longitude: PropTypes.number,
}
export default PropertyMap;